import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/image/logo.png")